import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import { Datepicker } from "stimulus-datepicker"
import NestedForm from "stimulus-rails-nested-form"
import Reveal from "stimulus-reveal-controller"

const application = Application.start()
application.register("datepicker", Datepicker)
application.register("nested-form", NestedForm)
application.register("reveal", Reveal)

// Configure Stimulus development experience
// application.warnings = true
// application.debug = process.env.NODE_ENV === "development"
window.Stimulus = application

// Automatically load controllers from ViewComponents directory.
const context = require.context(
  "../../components/",
  true,
  /(.*)\/.+_controller\.js$/
)

Stimulus.load(definitionsFromContext(context))

export { application }

document.addEventListener("turbo:before-fetch-request", async event => {
  document.body.classList.add("wait")
})

document.addEventListener("turbo:before-fetch-response", async event => {
  document.body.classList.remove("wait")
})

document.addEventListener("turbo:before-cache", async event => {
  document.body.classList.remove("wait")
})

document.addEventListener("turbo:before-stream-render", (event) => {
  if (event.target.action === "remove") {
    const targetFrame = document.getElementById(event.target.target)
    if (targetFrame.dataset.fadeOut) {
      event.preventDefault()
      const elementBeingAnimated = targetFrame
      elementBeingAnimated.classList.add("animate-fade-out")
      elementBeingAnimated.addEventListener("animationend", () => {
        targetFrame.remove()
      })
    }
  }
})

